import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";

import {
  FirewallSubscriptionDetailsGQL,
  FirewallSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { PAGE_TAB_CONFIG_DEFAULT } from "../../../../components/subscription-detail/page-tab/tab-config";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { FirewallSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { FirewallSubscriptionViewComponent } from "./firewall-subscription-view";

@Component({
  selector: "firewall-subscription",
  templateUrl: "firewall-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FirewallSubscriptionViewComponent, SubscriptionPageComponent],
})
export class FirewallSubscriptionComponent extends GenericSubscription<
  FirewallSubscriptionDetailsQuery,
  FirewallSubscriptionDetails
> {
  protected query = inject(FirewallSubscriptionDetailsGQL);

  tabConfig = signal(PAGE_TAB_CONFIG_DEFAULT);

  protected onQuerySuccess(data: FirewallSubscriptionDetailsQuery): FirewallSubscriptionDetails {
    return data.firewallDetails as FirewallSubscriptionDetails;
  }
}
